module.exports = __webpack_public_path__ + "img/banner_7.095c57bf.png";